import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class PartnersService {
  constructor(private restService: RestService) {}

  search(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('partners/search', val_params);
  }

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('partners/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('partners/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('partners/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('partners/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('partners/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('partners/delete', val_id);
  }
}
